import React from 'react';
import clsx from 'clsx';

import { makeStyles } from "@material-ui/core/styles"
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { useAuth } from './contexts/AuthContext'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import logo from "./assets/main_page.png"

import {
  BrowserRouter as Router,
  Link, useHistory
} from "react-router-dom";

import {
  Drawer, List, ListItem,
  ListItemIcon, ListItemText,
  Container, Typography,
} from "@material-ui/core";

import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from '@material-ui/icons/Info';

import useToken from './useToken';
import Routes from './Routes';
import Login from './components/Login/Login'

const drawerWidth = 250;

const useStyles = makeStyles((theme) => ({
  drawerPaper: { width: 'inherit' },
  link: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    background: '#657a71',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    marginLeft: 'auto',
    marginRight: 15,
    alignItems: 'right',
  },
  email: {
    alignItems: 'right',
    marginRight: 5
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    paddingTop: 80,
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
    paddingTop: 80,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  logo: {
    width: 35,
    height: 35,
  }
}))

function App() {
  const classes = useStyles();
  const { token, setToken } = useToken();
  const { currentUser, logout } = useAuth();
  const [open, setOpen] = React.useState(true);
  const history = useHistory()

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  const handleLogout = () => {
    try {
      logout()
      history.push('/')
      window.location.reload();
    } catch(err) {
      console.log(err.message)
      console.log("Fail to log out.")
    }
  }

  if (!token) {
    return <Login setToken={setToken} />
  }  

  let email = "unknown"
  if (currentUser) {
    email = currentUser.email
  }

  return (
      <div className={classes.root}>
      <CssBaseline />
      <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
          >
            <MenuIcon />
          </IconButton>
          <img className={classes.logo} src={logo}/>
          <Typography component="h1" variant="h6" color="white" noWrap className={classes.title}>
            YILI
          </Typography>
          <Typography variant="body1" color="white" noWrap className={classes.email}>
            {email}
          </Typography>
          <ExitToAppIcon color="white" onClick={handleLogout}/>
          <IconButton color="white">
            <Badge badgeContent={0} color="primary">
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Toolbar>
      </AppBar>
    <Router>
      <div style={{ display: 'flex' }}>
        <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
        >
          <List>
            <Link to="/digital_farm" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary={"Digital Farm"} />
              </ListItem>
            </Link>
            <Link to="/environment" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <InfoIcon />
                </ListItemIcon>
                <ListItemText primary={"Environment"} />
              </ListItem>
            </Link>
            <Link to="/cultivation_report" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <InfoIcon />
                </ListItemIcon>
                <ListItemText primary={"Cultivation Report"} />
              </ListItem>
            </Link>
            <Link to="/cultivation_records" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <InfoIcon />
                </ListItemIcon>
                <ListItemText primary={"Cultivation Records"} />
              </ListItem>
            </Link>
            <Link to="/harvest_report" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <InfoIcon />
                </ListItemIcon>
                <ListItemText primary={"Harvest Report"} />
              </ListItem>
            </Link>
            <Link to="/cultivation_models" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <InfoIcon />
                </ListItemIcon>
                <ListItemText primary={"Cultivation Model"} />
              </ListItem>
            </Link>
            <Link to="/irrigation" className={classes.link}>
              <ListItem button>
                <ListItemIcon>
                  <InfoIcon />
                </ListItemIcon>
                <ListItemText primary={"Irrigation"} />
              </ListItem>
            </Link>
          </List>
        </Drawer>
        <main className={classes.content}> 
          <Routes/>
        </main>
      </div>
    </Router>
    </div>
  );
}

export default App;
